{
    "BANNER": {
        "TITLE": " Nationwide Access to Premium Healthcare",
        "DESCRIPTION": "Pay direct for routine care at the time of service, and less than what you would with insurance because of copays, deductibles, and coinsurances. Our packages are perfect as standalone protection, or as supplements to insurance plans.",
        "BTNTEXT": "View Plans",
        "BANNER_SLIDES": [
            {
                "title": "Fast, Long-lasting Dry Mouth Relief",
                "subtitle": "Suffering from dry mouth symptoms? You are not alone. In the U.S., 22% of adults suffer from dry mouth for various reasons. Don't let your dry mouth symptoms keep you from seeking relief and taking back control of your mouth and your confidence. With Aquoral, you will treat your dry mouth symptoms and gain access to WoW Health's platform of healthcare solutions.",
                "buttonText": "View Plans",
                "buttonAction": "visit",
                "link": "/join",
                "bannerClass": "aquoral-banner"
            },
            {
                "title": "Fast, Long-lasting Dry Mouth Relief",
                "subtitle": "Suffering from dry mouth symptoms? You are not alone. In the U.S., 22% of adults suffer from dry mouth for various reasons. Don't let your dry mouth symptoms keep you from seeking relief and taking back control of your mouth and your confidence. With Aquoral, you will treat your dry mouth symptoms and gain access to WoW Health's platform of healthcare solutions.",
                "buttonText": "View Plans",
                "buttonAction": "visit",
                "link": "/join",
                "bannerClass": "aquoral-banner"
            },
            {
                "title": "Fast, Long-lasting Dry Mouth Relief",
                "subtitle": "Suffering from dry mouth symptoms? You are not alone. In the U.S., 22% of adults suffer from dry mouth for various reasons. Don't let your dry mouth symptoms keep you from seeking relief and taking back control of your mouth and your confidence. With Aquoral, you will treat your dry mouth symptoms and gain access to WoW Health's platform of healthcare solutions.",
                "buttonText": "View Plans",
                "buttonAction": "visit",
                "link": "/join",
                "bannerClass": "aquoral-banner"
            }
        ]
    },
    "SPRAY_SECTION": {
        "TITLE": "Why Choose Aquoral Mouth Spray?",
        "DESCRIPTION": "Aquoral is a clinically proven mouth spray that provides fast and long-lasting relief from dry mouth symptoms. Its unique lipid-based formula forms a protective film over the mucous membranes in your mouth, keeping them moisturized and lubricated. With Aquoral, you can say goodbye to the discomfort of dry mouth and enjoy improved oral health and overall well-being.",
        "BENEFITS_LIST": [
            {
                "id": "01",
                "title": "Fast Action",
                "description": "Instant, prolonged relief with fewer applications.",
                "icon": "voltage.svg"
            },
            {
                "id": "02",
                "title": "On-the-Go Relief",
                "description": "Convenient and portable, use anywhere.",
                "icon": "spray.svg"
            },
            {
                "id": "03",
                "title": "Targeted Hydration",
                "description": "Targets dry areas directly for hydration.",
                "icon": "freshener.svg"
            },
            {
                "id": "04",
                "title": "Long-Lasting Comfort",
                "description": "Sustained relief for up to 6 hours",
                "icon": "smile-peace.svg"
            },
            {
                "id": "05",
                "title": "Oral Health Support",
                "description": "Helps prevent oral damage & tooth decay.",
                "icon": "mouth.svg"
            },
            {
                "id": "06",
                "title": "Improved Quality of Life",
                "description": "Find relief and restore your quality of life",
                "icon": "tick-circle-orange.svg"
            }
        ]
    },
    "CLINICAL_BENEFITS": {
        "TITLE": "Experience the WoW Health Difference",
        "DESCRIPTION": "With your Aquoral purchase, you gain access to WoW Health's platform of healthcare solutions. Our membership plans are designed to provide you with comprehensive healthcare access and benefits, all without the need for insurance. Enjoy virtual urgent care, crisis tele-counseling, virtual primary care, discounted in-person visits for primary and urgent care, specialist consultations, up to 80% off medications, discounts on lab tests, imaging services, procedures and surgeries, and dental and vision benefits where available.",
        "BENEFITS_LIST": [
            {
                "title": "Innovative Formula",
                "description": "Lipid-based spray lubricates and provides a protective shield of the oral mucosa that does not wash away",
                "bgImage": "d-shape"
            },
            {
                "title": "Powerful Solution",
                "description": "Helps prevent mucosal damage & tooth decay while improving the ability to chew, taste, swallow, & speak",
                "bgImage": "circles"
            },
            {
                "title": "Fast & Long-lasting",
                "description": "Two quick sprays provide rapid relief that lasts for 4 to 6 hours, and reduces the need for frequent dosing",
                "bgImage": "m-shape"
            }
        ]
    },
    "DRY_MOUTH_SYMPTOMS": {
        "MINI_TITLE": "Symptoms",
        "TITLE": "Signs & Symptoms of Dry Mouth",
        "DESCRIPTION": "If you feel a constant dryness or stickiness, or find it uncomfortable to eat or talk, you may be experiencing dry mouth.",
        "SYMPTOMS_LIST": [
            "Altered sense of Taste",
            "Tooth Decay",
            "Bad Breath",
            "Discolored, cracked tongue",
            "Mouth Sore",
            "Repeat Cavities",
            "Difficulty chewing, swallowing, and speaking",
            "Persistent dryness or sensation of cottonmouth",
            "CPAP users - Waking from Sleep"
        ]
    },
    "MEMBERSHIP": {
        "MINI_TITLE": "Affordable Healthcare solution for you!",
        "TITLE": "Healthcare access with membership, no insurance needed",
        "DENTAL_VISION_LABEL": "Add Dental & Vision Benefits",
        "REDUCE_IN_PERSON_LABEL": " Reduce In-person Primary Care to $10 & Urgent Care to $25 ",
        "LABEL": "This plan includes:",
        "NOTE1": "**Comprehensive plan is not available to residents of WA",
        "NOTE2": "**HealthShare is not available in WA",
        "NOTE3": "**75% off for each additional family member",
        "MEMBERNOTES_LABEL": "Notes:",
        "MEMBERNOTES": " After 3 months, get one subsidized visit (50% reimbursement, up to $150). After 6 months, get a second subsidized visit. Can roll over 1 unused visit to the next year. ",
        "BTN_LABEL": "Get Started Now"
    },
    "FAQS": {
        "MINI_TITLE": "How it works",
        "TITLE1": "Frequently",
        "TITLE2": "Asked Questions",
        "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
        "LINK": "Visit Faqs Page",
        "FAQ_LIST": [
            {
                "title": "What is dry mouth?",
                "description": "Dry mouth, or xerostomia, occurs when your salivary glands dont produce enough saliva to keep your mouth moist. This can lead to discomfort, difficulty in speaking and swallowing, and increased risk of tooth decay and infections."
            },
            {
                "title": "How does Aquoral work?",
                "description": "Aquoral uses a unique lipid-based formula containing Oxidized Glycerol Triester (OGT) to form a protective film over the mucous membranes in your mouth, keeping them moisturized and lubricated."
            },
            {
                "title": "How often should I use Aquoral?",
                "description": "For best results, use two sprays of Aquoral into the mouth 3 to 4 times a day, spreading the product onto inflamed or dry areas with your tongue."
            },
            {
                "title": "Is Aquoral safe to use?",
                "description": "Aquoral is clinically proven and designed to be safe for regular use by adults experiencing dry mouth symptoms. It contains ingredients like Oxidized Glycerol Triester (OGT), silicon dioxide, aspartame, and artificial flavoring."
            },
            {
                "title": "How long does the relief from Aquoral last?",
                "description": "Each application of Aquoral provides rapid relief that lasts for 4 to 6 hours, reducing the need for frequent dosing throughout the day."
            },
            {
                "title": "What is included in the WoW Health Basic plan that I will get with buying Aquoral mouth spray?",
                "description": "The WoW Health Basic plan includes virtual urgent care, crisis tele-counseling, virtual primary care, discounted in-person visits for primary and urgent care, specialist consultations, up to 80% off medications, discounts on lab tests, imaging services, procedures and surgeries, and dental and vision benefits where available."
            }
        ]
    }
}